import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <main className="mx-auto max-w-3xl px-4 py-10">
        <Link to="/" className="text-violet-400 hover:underline">← Back</Link>
        
        <h1 className="text-4xl font-bold mt-6 mb-4">Privacy Policy</h1>
        <p className="text-white/50 mb-8"><strong>Effective Date:</strong> February 2, 2026</p>

        <div className="prose prose-invert max-w-none space-y-6 text-white/70">
          <h2 className="text-2xl font-semibold text-white">What we collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Account info (email, identifiers)</li>
            <li>Workspace inputs (brand DNA, product/service details)</li>
            <li>Generated outputs (ads, scripts, variants)</li>
            <li>Usage logs (for reliability and security)</li>
            <li>Billing identifiers via Stripe (we don't store full card numbers)</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white mt-8">How we use it</h2>
          <p>To provide the Service, generate outputs, operate workspaces/roles, and improve performance.</p>

          <h2 className="text-2xl font-semibold text-white mt-8">Contact</h2>
          <p>
            Use the <Link to="/contact" className="text-violet-400 hover:underline">Contact page</Link> on OmniMarkHQ.com for privacy requests.
          </p>
        </div>
      </main>
    </div>
  );
}
